export const READ_NOTIFICATION = 'READ_NOTIFICATION'
export const GET_COUNTERS = 'GET_COUNTERS'
export const SET_ACCESS = 'SET_ACCESS'
